module.exports = __webpack_public_path__ + "static/media/photo.ea767fac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photo.jpg
// module id = 228
// module chunks = 0